import { Box } from "@mui/material";
import { memo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sortable from "sortablejs";
import { TicketPriorityChange } from "../../../../../../services/dashboard/dashboard.service";
import { IState } from "../../../../../../redux/reducers/rootReducers";
import { priorityToPriorityUpdate } from "../../../../../../redux/actions/TicketsManagement/TicketActionUtils";
import { ActionType } from "../../../../../../redux/actions/Snackbars";
import configs from "../../../../../../configs/config";

export const PriorityDropable = memo((props:any) =>{
//     console.log('configs',configs)
    const AllInfo = useSelector((state: IState) => state?.TicketsReducer?.alldataStructure);
    const {id,columnName} = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Sortable.create below only runs once (mount) - see StatusDropable.tsx /
    // NewtoMeTickets.tsx for the same fix and why it's needed.
    const allInfoRef = useRef(AllInfo);
    useEffect(() => { allInfoRef.current = AllInfo; }, [AllInfo]);

    useEffect(()=>{
        let allGroups: any = document.getElementById(`PriorityDropable-${id}`);
        if(!allGroups) return;
        var sortable = Sortable.create(allGroups, {
            animation: 150,
            group: "list",
            onAdd: function (e: any) {
                let isMyTickets = e.item.getAttribute("data-mytickets");
                let ticketId = e.item.getAttribute("data-ticket-id");
//                 console.log('isMyTickets',isMyTickets)
                if(isMyTickets === 'myTickets' || isMyTickets === 'newTickets'){
                    //alert('redirect')
                    navigate(`/home/ticket/${ticketId}?priority=${id}`)
                    return
                }
                ticketDropped(e)
                e.clone.replaceWith(e.item);
            },
        });
    },[])
    const ticketDropped = async (evt: any) => {
        let priorityId = evt.to.getAttribute("label-prioritycolid");
        let ticketId = evt.item.getAttribute("ticket-id");
        const droppedPriorityName = evt.to.getAttribute("label-prioritycolname");
//         console.log('Dropped Priority Name',columnName)
        const newPriorityInfo = allInfoRef.current?.priorityTypesById?.[priorityId];
        const tempObj = {
            sourceCode : configs.SOURCE,
            priorityId : +priorityId,
            priority : newPriorityInfo || { id: +priorityId, name: droppedPriorityName },
        }
        TicketPriorityChange(configs.SOURCE,
            ticketId,
            priorityId
        ).then((response: any) => {
            if(response && response?.status === 200){
                dispatch(priorityToPriorityUpdate(ticketId,tempObj,response,columnName));
            }else{
                const errMsg = response?.data && typeof response.data === 'string' ? response.data : `Ticket ${ticketId} priority update failed`;
                dispatch({type: ActionType.SNACKBAR, payload: {message: errMsg, severity: 'error', open: true}});
            }
        }).catch((e)=>{
//             console.log(e)
        });
    };
    return (<Box sx={{height:100,background:"#555"}} className="column-overlay" label-prioritycolid={id} label-prioritycolname={"column Name"} id={`PriorityDropable-${id}`}></Box>)
})
export default PriorityDropable;